<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Данные Выгодоприобретателя<br class="onlydesk"> (Застрахованного лица)</h3>
      <Step4Block ref="benefi" :active="active" v-for="(b, index) in beneficiaries"  :key="index"
        :index="index"  
        @filledChanged="filledBeneficiaries[index] = $event" 
        @dataChanged="beneficiaries[index] = $event "   />
      <SelInput text="Степень родства Заявителя с Застрахованным" name="applicant-relationship" :options="relationships" v-model="form.applicant.relationship" />
      <CheckBox v-if="beneficiaries.length == 1" name="insuredperson-is-beneficiary" v-model="copy" >Застрахованный совпадает с&nbsp;выгодоприобритателем</CheckBox>
      <TextInput :disabled="copy" @setError="errors.name = $event" v-model="form.insuredperson.name" text="ФИО застрахованного" name="insuredperson-name"/>
      <DateInput :disabled="copy" @setError="errors.birthdate = $event" name="insuredperson-birthdate" text="Дата рождения застрахованного" :range="false" v-model="form.insuredperson.birthdate" />      
      <AddBtn class="step4__addbutton" @click="addBeneficiary">Указать еще одного выгодоприобретателя (наследника)</AddBtn>
      <div class="step__line"></div>
      <Btn class="step__next" :disabled="!filled" @click="toNext">Далее</Btn>
    </div>
    </div>
</template>

<script>
import Btn from '../Btn.vue';
import AddBtn from '../AddBtn.vue';
import DateInput from '../inputs/DateInput.vue';
import TextInput from '../inputs/TextInput.vue';
import Step4Block from './Step4Block.vue';
import { mapState } from 'vuex';
import CheckBox from '../inputs/CheckBox.vue';
import SelInput from '../inputs/SelInput.vue';

export default {
  props: {
    active: { type: Boolean, default: false }
  },
  data: ()=>({
    copy: false,
    errors: {},
    beneficiaries: [ {} ],
    filledBeneficiaries: [ false ],
    relationships: ['','Супруг/Супруга','Сын/Дочь','Отец/Мать','Другое']
  }),
  components: { Step4Block, Btn, TextInput, DateInput, AddBtn, CheckBox, SelInput },
  methods: {
    addBeneficiary() {
      this.filledBeneficiaries.push(false)
      this.beneficiaries.push({})
      this.copy = false
    },
    toNext(){
      this.$store.commit('setBeneficiaries', this.beneficiaries)
      this.$store.commit('nextStep')
    },
    copyIfNeeded(){
      if (this.copy) {
        this.form.insuredperson.name = this.$refs.benefi[0].$data.data.name
        this.form.insuredperson.birthdate = this.$refs.benefi[0].$data.data.birthdate
      }
    }
  },
  computed: {
    ...mapState(['form']),
    filled(){
      for (let key in this.errors)
        if (this.errors[key]) return false
      if (this.filledBeneficiaries.includes(false)) return false
      if (!this.form.insuredperson.name || !this.form.insuredperson.birthdate) return false
      return true
    }
  },
  watch: {
    copy(val, old) {
      if (val != old) {
        this.copyIfNeeded()
        if (!val && this.beneficiaries.length == 1) {
          this.form.insuredperson.name = ''
          this.form.insuredperson.birthdate = ''
        }
      }
    },
    active() {
      this.copyIfNeeded()
    }
  }
}
</script>

<style lang="sass">
.step4__addbutton
  width: 585px
  max-width: 100%
  @include for-mob
    .addbtn__text
      text-align: left
</style>